import { apiGet, API_BASE } from "./client.js";
import { ApiCallError } from "./client.js";
import type {
  StatementVersionSummary,
  StatementPayload,
} from "./product-types.js";

export async function getLatestStatement(
  websiteId: string,
): Promise<StatementVersionSummary | null> {
  return apiGet<StatementVersionSummary | null>(
    `/websites/${websiteId}/statements`,
  );
}

export async function getStatementPayload(
  websiteId: string,
  versionId: string,
): Promise<StatementPayload | null> {
  try {
    return await apiGet<StatementPayload>(
      `/websites/${websiteId}/statements/${versionId}/payload`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}

export async function getStatementHtml(
  websiteId: string,
  versionId: string,
): Promise<string | null> {
  try {
    const res = await fetch(
      `${API_BASE}/websites/${websiteId}/statements/${versionId}/html`,
      { credentials: "include" },
    );
    if (!res.ok) return null;
    return res.text();
  } catch {
    return null;
  }
}
